import {NgModule} from '@angular/core';
import {AmSearchFlexibleAgentComponent} from "./search/am-search-flexible-agent/am-search-flexible-agent.component";
import {
    AmSearchFlexibleAgentPoolComponent
} from "./search/am-search-flexible-agent-pool/am-search-flexible-agent-pool.component";
import {
    AmAgentActiveObjectsComponent
} from "./component/protected-components/am-agent-active-objects/am-agent-active-objects.component";
import {
    AmAgentMainActiveObjectsComponent
} from "./component/protected-components/am-agent-main-active-objects/am-agent-main-active-objects.component";
import {AmConfigPage} from "./page/overview/config/am-config.page";
import {AmTestPage} from "./page/overview/am-test.page.ts/am-test.page";
import {
    AgentCalendarManagementComponent
} from "./component/protected-components/agent-calendar-management/agent-calendar-management.component";
import {
    AmAgentAffiliateComponent
} from "./component/protected-components/am-agent-affiliate/am-agent-affiliate.component";
import {
    AmAffiliateScoreboardComponent
} from "./component/protected-components/am-affiliate-scoreboard/am-affiliate-scoreboard.component";
import {AmAgentOverviewPage} from "./page/overview/am-agent-overview-page/am-agent-overview.page";
import {
    AgentInfoDetailObjectComponent
} from "./component/protected-components/agent-info-detail-object-component/agent-info-detail-object.component";
import {
    AgentPoolInfoDetailObjectComponent
} from "./component/protected-components/agent-pool-info-detail-object-component/agent-pool-info-detail-object.component";
import {DragDropModule} from "primeng/dragdrop";
import {NsModule} from "../ns/ns.module";
import {AmAppointmentListPage} from "./page/overview/am-appointment-list-page/am-appointment-list.page";
import {AmAgentMapComponent} from "./component/protected-components/am-agent-map/am-agent-map.component";
import {FloatLabelModule} from "primeng/floatlabel";
import {AgentOverviewPage} from "./page/agent-overview-page/agent-overview.page";
import {UmModule} from "../um/um.module";
import {
    AgentStatisticsComponent
} from "./page/agent-overview-page/components/statisticsComponent/agent-statistics.component";
import {AgentKpiComponent} from "./page/agent-overview-page/components/kpiComponent/agent-kpi.component";
import {
    AgentInfoDetailObjectFullComponent
} from "./component/protected-components/agent-info-detail-object-component/view/agent-info-detail-object-full/agent-info-detail-object-full.component";
import {
    AgentInfoDetailObjectSideComponent
} from "./component/protected-components/agent-info-detail-object-component/view/agent-info-detail-object-side/agent-info-detail-object-side.component";
import {
    AgentInfoDetailObjectBaseComponent
} from "./component/protected-components/agent-info-detail-object-component/view/agent-info-detail-object-base.component";
import {AM_ENTITY_SERVICE_PROVIDERS} from "./am.entity-provider";
import {CoreModule} from "../../core/core.module";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {AM_TEST_PROVIDERS} from "./test/am-test-definition";
import {AgentObjectComponent} from "./component/object-components/agent-object-component/agent-object.component";

@NgModule({
    declarations: [
        AmSearchFlexibleAgentComponent,
        AmSearchFlexibleAgentPoolComponent,
        AmAgentActiveObjectsComponent,
        AmAgentMainActiveObjectsComponent,
        AmConfigPage,
        AmTestPage,
        AgentCalendarManagementComponent,
        AmAgentAffiliateComponent,
        AmAffiliateScoreboardComponent,
        AmAgentOverviewPage,
        AgentInfoDetailObjectComponent,
        AgentPoolInfoDetailObjectComponent,
        AmAppointmentListPage,
        AmAgentMapComponent,
        AgentOverviewPage,
        AgentStatisticsComponent,
        AgentKpiComponent,
        AgentInfoDetailObjectFullComponent,
        AgentInfoDetailObjectSideComponent,
        AgentInfoDetailObjectBaseComponent,
        AgentObjectComponent,

    ],
    exports: [
        AmSearchFlexibleAgentComponent,
        AmSearchFlexibleAgentPoolComponent,
        AmAgentActiveObjectsComponent,
        AmAgentMainActiveObjectsComponent,
        AgentCalendarManagementComponent,
        AmAgentOverviewPage,
        AgentInfoDetailObjectComponent,
        AgentPoolInfoDetailObjectComponent,
        AmAppointmentListPage,
        AgentInfoDetailObjectFullComponent,
        AgentInfoDetailObjectSideComponent,
        AgentInfoDetailObjectBaseComponent,
        AmAgentMapComponent,

    ],
    imports: [
        CoreModule,
        DragDropModule,
        NsModule,
        FloatLabelModule,
        UmModule,
    ],
    providers: [AM_ENTITY_SERVICE_PROVIDERS, AM_TEST_PROVIDERS]
})
export class AmModule implements DynamicModule {

    alias = 'am';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return AgentKpiComponent;
    }

    getStatisticsComponent() {
        return AgentStatisticsComponent;
    }
}
